import { useState } from "react";
import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { common, financedEmissions } from "../../../i18n";
import { TabMenu, TabMenuData } from "../../../components/tabMenu/TabMenu";
import MasterDetail from "./MasterDetail";
import AllLoans from "./AllLoans";

// Bulk Import is hidden for now; BulkImport.tsx stays for when it comes back.
type MainTab = "borrowers" | "all-loans";

const Borrowers = () => {
  const { t } = useTranslation([financedEmissions, common], {
    nsMode: "fallback",
  });
  const [tab, setTab] = useState<MainTab>("borrowers");
  const { borrowerId } = useParams<{ borrowerId: string }>();

  // A borrower detail takes over the whole page — Figma shows no Borrowers /
  // All Loans / Bulk Import tabs there, just "Back to Borrowers".
  if (borrowerId) return <MasterDetail />;

  const tabs: TabMenuData[] = [
    { pathname: "borrowers", name: "Tab-Overview", label: t("Tab-Overview") },
    { pathname: "all-loans", name: "Tab-All-Loans", label: t("Tab-All-Loans") },
  ];

  return (
    <Box display="flex" flexDirection="column" gap="20px">
      <TabMenu
        type="underline"
        size="page"
        tabMenuData={tabs}
        value={tab}
        onChange={(k) => setTab(k as MainTab)}
      />
      {tab === "borrowers" && <MasterDetail />}
      {tab === "all-loans" && <AllLoans />}
    </Box>
  );
};

export default Borrowers;
